import {Tooltip} from 'platform/components';
import {Icon, ThemeIconKey} from 'platform/foundation';
import {css} from 'styled-components';

import {MouseEvent, Ref} from 'react';
import {Link, useLocation} from 'react-router-dom';

import {UserSidebarIconSize} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {composePath, pushGtmEvent, RequiredTestIdProps} from 'shared/web';

import {SIDEBAR_DESKTOP_ICON_SIZE} from '../constants/sidebarDesktopIconSize';
import {NavigationButton} from './NavigationButton';

interface SidebarItemProps extends RequiredTestIdProps {
  path: string;
  isActive: boolean;
  title: string;
  iconSize: UserSidebarIconSize;
  icon?: ThemeIconKey;
  ref?: Ref<HTMLAnchorElement>;
  action?: () => void | Promise<void>;
}

export function SidebarLink(props: SidebarItemProps) {
  const location = useLocation();

  return (
    <Tooltip offset={8} placement="right" label={i18n.t(props.title)}>
      <Link
        ref={props.ref}
        to={composePath(props.path, {isSearchParamsPreserved: false})}
        data-testid={props['data-testid']}
        onClick={(event: MouseEvent<HTMLAnchorElement>) => {
          const isSamePath = location.pathname === props.path;

          if (props.action) {
            event.preventDefault();
            props.action();
          }

          if (isSamePath) {
            event.preventDefault();
          }

          pushGtmEvent({
            event: 'button_click',
            event_id: 'sidebar_item_click',
            value: props.path,
          });
        }}
        tabIndex={-1}
        // Link is not react component, there is no other way to style it
        // eslint-disable-next-line react/forbid-component-props
        css={css`
          &:focus {
            outline: none;
          }
        `}
      >
        <NavigationButton isActive={props.isActive}>
          <Icon
            size={SIDEBAR_DESKTOP_ICON_SIZE[props.iconSize]}
            value={props.icon}
            color="palettes.neutral.10.100"
          />
        </NavigationButton>
      </Link>
    </Tooltip>
  );
}
